import React, { useEffect, useState } from "react";
import "./essentiel.css";

const MOBILE_BREAKPOINT = 1080;

const scrollToMenuList = () => {
  const target = document.querySelector(".sidebar-container");
  if (!target) {
    return;
  }

  const top = target.getBoundingClientRect().top + window.pageYOffset - 76;
  window.scrollTo({
    top: Math.max(top, 0),
    behavior: "smooth",
  });
};

export default function EssentielBackToListButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateVisibility = () => {
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        setIsVisible(false);
        return;
      }

      const letters = document.querySelector(".alphabet-column");
      if (!letters) {
        setIsVisible(false);
        return;
      }

      const lettersRect = letters.getBoundingClientRect();
      const content = document.querySelector(".emol_global_card, .droits_fixes_intro, .droits_fixes_card");
      const contentRect = content?.getBoundingClientRect();

      const lettersAreOutOfView = lettersRect.bottom < 120;
      const acteIsVisible = contentRect ? contentRect.top < window.innerHeight - 140 : false;

      setIsVisible(lettersAreOutOfView && acteIsVisible);
    };

    updateVisibility();

    window.addEventListener("scroll", updateVisibility, { passive: true });
    window.addEventListener("resize", updateVisibility);

    return () => {
      window.removeEventListener("scroll", updateVisibility);
      window.removeEventListener("resize", updateVisibility);
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <button
      type="button"
      className="essentiel_mobile_back_button"
      onClick={scrollToMenuList}
      aria-label="Retour à la liste"
      title="Retour à la liste"
    >
      <span className="essentiel_mobile_back_button_icon" aria-hidden="true">
        ↑
      </span>
    </button>
  );
}
